import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';

import {
    AddressType,
    CmsPageContentIdentifier,
    CmsPageContentType,
    Feature,
    HouseholdConfigurationType,
    ReduxStateType,
    ResultType,
} from '@/types/av-check';
import {interpolate} from '@/utils';
import {actions} from '@/redux/av-check';

import StaticContentModal from '@/components/modal/static-content-modal';
import useMaxBandwidthInformation from '@/components/av-check/PositiveResult/use-max-bandwidth-information';
import {Alert, Link} from '@/components/compendium';
import {buildCheckOtherAddressData, pushToTefDataLayer,} from '@/services/tracking';

export interface PositiveResultProps {
}

export interface StateProps {
  address: AddressType,
  result?: ResultType
  cmsContent: CmsPageContentType,
  resetCityList: string[],
  resetStreetList: string[],
  enabledFeatures?: Feature[],
}

export interface DispatchProps {
  setAddress: Function,
  setHouseholdConfig: Function,
  setResult: Function,
  setResultError: Function,
  resetCityList: Function,
  resetStreetList: Function,
  resetTrackingInfo: Function
}

const PositiveResult = ({
  address,
  result,
  cmsContent,
  setAddress,
  setHouseholdConfig,
  setResult,
  setResultError,
  resetCityList,
  resetStreetList,
  resetTrackingInfo,
  enabledFeatures
} : PositiveResultProps & StateProps & DispatchProps) => {
  if (!result) {
    return null;
  }

  const bandwidthModalOpenerId = 'bandwidth_modal';
  const infoIconMarkup = `<a class="info" data-toggle="modal" href="#${bandwidthModalOpenerId}"/>`;

  const modalElements = useMaxBandwidthInformation(cmsContent, result.maxBandwidthForAccessTechnology,enabledFeatures);

  let headline: string;
  let content: string;

    headline = interpolate(cmsContent[CmsPageContentIdentifier.SuccessMessageBandwidthTitle],
      { maxBandwidth: result.maxBandwidth.text });
    content = interpolate(cmsContent[CmsPageContentIdentifier.SuccessMessageMaxBandwidthAddress], {
      street: address.street, houseNumber: address.houseNumber, zipCode: address.zipCode, city: address.city, infoIcon: infoIconMarkup,
    });


  return (
    <>
      <StaticContentModal
        openerId={bandwidthModalOpenerId}
        displayCloseButton
        titleContent={modalElements.title}
      >
        <p dangerouslySetInnerHTML={{ __html: modalElements.content }} />
      </StaticContentModal>
      <Alert
        type={Alert.Type.SUCCESS}
        noBorder
        headlineContent={headline}
        links={[
          <Link
            linkTextContent={cmsContent[CmsPageContentIdentifier.CheckOtherAddressLink]}
            href=""
            onClick={() => {
              const resultAddress = `${address.zipCode} ${address.city}`;
              pushToTefDataLayer(window, buildCheckOtherAddressData(resultAddress));

              setResult(undefined);
              setResultError(false);
              setAddress({
                zipCode: '',
                city: '',
                street: '',
                houseNumber: '',
              });
              setHouseholdConfig({
                personInHousehold: 0,
                usageTypes: [],
              });
              resetCityList(),
              resetStreetList(),
              resetTrackingInfo();
            }}
          />,
        ]}
      >
        <span dangerouslySetInnerHTML={{ __html: content }} />
      </Alert>
    </>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
  address: state.address,
  result: state.result,
  cmsContent: state.cmsContent,
  resetCityList: state.cityList,
  resetStreetList: state.streetList,
  enabledFeatures: state.enabledFeatures,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setAddress: (address: AddressType) => dispatch(actions.setAddress(address)),
  setHouseholdConfig: (householdConfig: HouseholdConfigurationType) => dispatch(actions.setHouseholdConfig(householdConfig)),
  setResult: (result: ResultType) => dispatch(actions.setResult(result)),
  setResultError: (isError: boolean) => dispatch(actions.setResultError(isError)),
  resetCityList: () => dispatch(actions.setCityList(undefined)),
  resetStreetList: () => dispatch(actions.setStreetList(undefined)),
  resetTrackingInfo: () => dispatch(actions.setTrackingInfo({isFirstSliderView: true, sliderTariffPositions: {}}))
});

export default connect(mapStateToProps, mapDispatchToProps)(PositiveResult);
